import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Answers.styles';
import i18n from 'i18next';

const AnswersStudentFullTest = ({ text }) => (
  <S.StudentContainer>
    <S.CommonTitle>
      {i18n.t('modules.submissions.common.header.titles.student-answer')}:
    </S.CommonTitle>
    <S.StudentAnswerText dangerouslySetInnerHTML={{ __html: text }} />
  </S.StudentContainer>
);

AnswersStudentFullTest.propTypes = {
  text: PropTypes.string.isRequired,
};

export { AnswersStudentFullTest };
